/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddServiceproviderTeamMemberRequest
 */
export interface AddServiceproviderTeamMemberRequest {
    /**
     * Email address of the new team member.
     */
    email: string;
    /**
     * First name of the new team member.
     */
    firstname: string;
    /**
     * Last name of the new team member.
     */
    lastname: string;
}

/**
 * Check if a given object implements the AddServiceproviderTeamMemberRequest interface.
 */
export function instanceOfAddServiceproviderTeamMemberRequest(value: object): value is AddServiceproviderTeamMemberRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function AddServiceproviderTeamMemberRequestFromJSON(json: any): AddServiceproviderTeamMemberRequest {
    return AddServiceproviderTeamMemberRequestFromJSONTyped(json, false);
}

export function AddServiceproviderTeamMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddServiceproviderTeamMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
    };
}

export function AddServiceproviderTeamMemberRequestToJSON(json: any): AddServiceproviderTeamMemberRequest {
    return AddServiceproviderTeamMemberRequestToJSONTyped(json, false);
}

export function AddServiceproviderTeamMemberRequestToJSONTyped(value?: AddServiceproviderTeamMemberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

